<template>
  <div
    class="modal fade"
    id="assignCollectionOfficerModal"
    tabindex="-1"
    data-backdrop="static"
    data-keyboard="false"
    role="dialog"
    aria-labelledby="assignCollectionOfficerModalLabel"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            @click="() => {onResetForm();}"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4
            class="modal-title"
            id="assignCollectionOfficerModalLabel"
          >
            {{ $t('string.assign_collection_officer') }}
          </h4>
        </div>
        <div class="modal-body">
          <div
            class="form-group"
            :class="{'has-error' : validations['collection_officer_id']}"
          >
            <label
              for="loanOfficers"
              class="required"
            >{{ $t('string.collection_officer') }}</label>
            <multiselect
              v-model="collection_officer"
              :options="collection_officers"
              id="loanOfficers"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
              :deselect-label="$t('string.press_enter_to_remove')"
              :select-label="$t('string.press_enter_to_select')"
              :selected-label="$t('string.multiple_select_selected')"
              :placeholder="$t('string.choose_collection_officer')"
              label="name"
              track-by="id"
            />
            <template v-if="validations['collection_officer_id']">
              <span class="help-block">{{ validations['collection_officer_id'][0] }}</span>
            </template>
          </div>
        </div>
        <div class="modal-footer">
          <button
            @click="() => {onResetForm()}"
            type="button"
            ref="close"
            class="btn btn-default"
            data-dismiss="modal"
          >
            {{ $t('button.close') }}
          </button>
          <button
            type="button"
            @click="onSave"
            :disabled="isSaveWaiting"
            class="btn btn-primary"
          >
            <i
              class="fa fa-spinner fa-spin"
              v-if="isSaveWaiting"
            /> {{ $t('button.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'AssignCollectionOfficerModal',
  data () {
    return {
      collection_officers: [],
      validations: {},
      isSaveWaiting: false,
      collection_officer: null
    }
  },
  computed: {
    ...mapState('collectionOfficer', {
      borrow_id: 'borrow_id'
    })
  },
  watch: {
    borrow_id () {
      if (this.borrow_id) {
        this.getCollectionOfficerByBorrower()
      }
    }
  },
  methods: {
    ...mapActions('collectionOfficer', {
      setBorrowId: 'setBorrowId'
    }),
    onResetForm () {
      this.validations = {}
      this.collection_officer = null
      this.$refs.close.click()
      this.setBorrowId(null)
    },
    onSave () {
      this.isSaveWaiting = true
      this.$axios.post(this.$base_api + '/api/v1/collection-officer/store', {
        borrow_id: this.borrow_id,
        collection_officer_id: this.collection_officer ? this.collection_officer.id : null
      }).then(({ data }) => {
        if (data.data) {
          this.$emit('refreshList')
          this.onResponseSuccess()
          this.onResetForm()
        }
      }).catch((error) => {
        if (error.response.status === 422) {
          this.validations = error.response.data.errors
        } else {
          this.onResponseError(error)
        }
      }).finally(() => {
        this.isSaveWaiting = false
      })
    },
    getCollectionOfficers () {
      this.$axios.post(this.$base_api + '/api/v4/backend/loan-officer-assignment/loan-officer-list')
        .then(({ data }) => {
          if (data.data) {
            this.collection_officers = data.data.map((user) => {
              return {
                id: user.id,
                name: user.name
              }
            })
          }
        })
        .catch((error) => {
          this.onResponseError(error)
        })
        .finally(() => {
          this.isSaveWaiting = false
        })
    },
    getCollectionOfficerByBorrower () {
      this.$axios.post(this.$base_api + '/api/v1/collection-officer/get-collection-officer-by-borrower', {
        borrow_id: this.borrow_id
      }).then(({ data }) => {
        if (data.data) {
          const collection_officer = data.data
          this.collection_officer = {
            id: collection_officer.id,
            name: collection_officer.name
          }
        }
      }).catch((error) => {
        this.onResponseError(error)
      }).finally(() => {
        this.isSaveWaiting = false
      })
    }
  },
  mounted () {
    this.getCollectionOfficers()
  }
}
</script>

<style scoped>

</style>
